module.exports = __webpack_public_path__ + "static/media/icon-close.54e63c9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/compare-section/product-compare-card/img/icon-close.svg
// module id = 965
// module chunks = 1